export enum BulkOperationJobType {
  WorkflowBulkAssignment = 'WORKFLOW_BULK_ASSIGNMENT',
  BulkPublishDocuments = 'BULK_PUBLISH_DOCUMENTS',
  BulkUploadDocuments = 'BULK_UPLOAD_DOCUMENTS',
}
